import React from 'react';
import {
  ATMField,
  ATMForm,
  ATMGrid,
  ATMSelect,
  ATMInput,
} from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { FlightOperatorFormSchema } from 'src/models/flight-operator.model';

type IProp = {
  formRef: React.RefObject<HTMLFormElement>;
  defaultValues: any;
  handleSubmit: (data) => void;
  handleEnable: (value) => void;
};

const FlightOperatorsForm: React.FC<IProp> = ({
  formRef,
  defaultValues = {},
  handleSubmit,
  handleEnable,
}) => {
  return (
    <div className="form-container">
      <ATMForm
        ref={formRef}
        onSubmit={handleSubmit}
        mode="onBlur"
        defaultValues={defaultValues}
        validationSchema={FlightOperatorFormSchema}
      >
        {({ control, errors, formState }) => {
          handleEnable(formState.isDirty);

          return (
            <ATMGrid>
              <ATMGrid.Row columns="equal">
                <ATMGrid.Column>
                  <ATMField
                    label={Lang.LBL_OPERATOR_NAME}
                    name="name"
                    control={control}
                    as={ATMInput}
                    placeholder={Lang.LBL_ENTER}
                    required
                    error={errors.name}
                  />
                  <ATMField
                    as={ATMInput}
                    type="hidden"
                    name="operatorId"
                    control={control}
                    error={errors.operatorId}
                  />
                </ATMGrid.Column>
                <ATMGrid.Column>
                  <ATMField
                    label={Lang.LBL_OPERATOR_EMAIL}
                    name="email"
                    control={control}
                    as={ATMInput}
                    placeholder={Lang.LBL_ENTER}
                    required
                    error={errors.email}
                  />
                </ATMGrid.Column>
              </ATMGrid.Row>
              <ATMGrid.Row columns="equal">
                <ATMGrid.Column>
                  <ATMField
                    label={Lang.LBL_ACTIVE}
                    name="activeFlag"
                    control={control}
                    as={ATMSelect}
                    placeholder={Lang.LBL_SELECT}
                    options={[
                      { key: 'true', text: Lang.LBL_YES, value: true },
                      { key: 'false', text: Lang.LBL_NO, value: false },
                    ]}
                    onChange={([_, { value }]) => value}
                    required
                    error={errors.activeFlag}
                    selectOnBlur={false}
                  />
                </ATMGrid.Column>
                <ATMGrid.Column>
                  <ATMField
                    label={Lang.LBL_DISPATCH}
                    name="dispatchFlag"
                    control={control}
                    as={ATMSelect}
                    placeholder={Lang.LBL_SELECT}
                    options={[
                      { key: 'true', text: Lang.LBL_YES, value: true },
                      { key: 'false', text: Lang.LBL_NO, value: false },
                    ]}
                    onChange={([_, { value }]) => value}
                    required
                    error={errors.dispatchFlag}
                    selectOnBlur={false}
                  />
                </ATMGrid.Column>
              </ATMGrid.Row>
            </ATMGrid>
          );
        }}
      </ATMForm>
    </div>
  );
};

export default FlightOperatorsForm;
